import { render, staticRenderFns } from "./RevenuesChart.vue?vue&type=template&id=01d65e19&"
import script from "./RevenuesChart.vue?vue&type=script&lang=js&"
export * from "./RevenuesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d65e19')) {
      api.createRecord('01d65e19', component.options)
    } else {
      api.reload('01d65e19', component.options)
    }
    module.hot.accept("./RevenuesChart.vue?vue&type=template&id=01d65e19&", function () {
      api.rerender('01d65e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/RevenuesChart.vue"
export default component.exports